import React from 'react'

import Icon, { Props } from '../icon'

export const AlertIcon: React.FC<Omit<Props, 'viewBox'>> = (props) => (
  <Icon viewBox="0 0 19 17" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      id="MyMilupa"
      stroke="none"
      strokeWidth="1"
    >
      <g
        fill="currentColor"
        fillRule="nonzero"
        id="MyMilupa---My-Orders---Desktop"
        transform="translate(-495.000000, -1606.000000)"
      >
        <g id="orders" transform="translate(443.000000, 259.000000)">
          <g id="order" transform="translate(0.000000, 1061.000000)">
            <g id="error" transform="translate(32.000000, 272.000000)">
              <path
                d="M36.7412398,30.7431641 C37.1160568,30.7431641 37.4388159,30.6234309 37.709517,30.3839645 C37.9802182,30.144498 38.1468035,29.8529737 38.209273,29.5093915 C38.2717425,29.1658093 38.2196846,28.8274328 38.0530993,28.4942622 L38.0530993,28.4942622 L30.5567596,15.5006067 C30.3693511,15.1674361 30.1038557,14.943587 29.7602735,14.8290596 C29.4166913,14.7145322 29.073109,14.7145322 28.7295268,14.8290596 C28.3859446,14.943587 28.1204492,15.1674361 27.9330407,15.5006067 L27.9330407,15.5006067 L20.436701,28.4942622 C20.2701157,28.8274328 20.2180578,29.1658093 20.2805273,29.5093915 C20.3429968,29.8529737 20.5095821,30.144498 20.7802833,30.3839645 C21.0509844,30.6234309 21.3737435,30.7431641 21.7485605,30.7431641 L21.7485605,30.7431641 L36.7412398,30.7431641 Z M29.9945341,25.2458483 L28.4952662,25.2458483 C28.3911504,25.2458483 28.3026519,25.2094078 28.2297708,25.1365267 C28.1568897,25.0636456 28.1204492,24.9855587 28.1204492,24.9022661 L28.1204492,24.9022661 L27.8705712,20.6543402 C27.8705712,20.5294013 27.9070118,20.4304912 27.9798928,20.3576101 C28.0527739,20.2847291 28.1412724,20.2482885 28.2453882,20.2482885 L28.2453882,20.2482885 L30.2444121,20.2482885 C30.3485279,20.2482885 30.4370264,20.2847291 30.5099075,20.3576101 C30.5827886,20.4304912 30.6192291,20.5294013 30.6192291,20.6543402 L30.6192291,20.6543402 L30.3693511,24.9022661 C30.3693511,24.9855587 30.3329106,25.0636456 30.2600295,25.1365267 C30.1871484,25.2094078 30.09865,25.2458483 29.9945341,25.2458483 L29.9945341,25.2458483 Z M29.2449002,28.6816707 C28.84926,28.6816707 28.5108836,28.5411143 28.2297708,28.2600015 C27.9486581,27.9788888 27.8081017,27.6405124 27.8081017,27.2448722 C27.8081017,26.8492321 27.9486581,26.5108556 28.2297708,26.2297429 C28.5108836,25.9486301 28.84926,25.8080738 29.2449002,25.8080738 C29.6405403,25.8080738 29.9789168,25.9486301 30.2600295,26.2297429 C30.5411422,26.5108556 30.6816986,26.8492321 30.6816986,27.2448722 C30.6816986,27.6405124 30.5411422,27.9788888 30.2600295,28.2600015 C29.9789168,28.5411143 29.6405403,28.6816707 29.2449002,28.6816707 Z"
                id=""
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

export default AlertIcon
